import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import SettingListItem from '../SettingListItem';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';
import { useSchool } from '../../../DataStore/SchoolContext';
import functions from '../../../util/functions';

const SchoolFeesConfig = () => {

    const {openSettings} = useTheme();

    const [activeRecord, setActiveRecord] = useState(null);
    const {getConfig, configListing} = useSchool();


    useEffect(()=>{
        getConfig();
    }, [])

    const handleRefresh = ()=>{
        getConfig(true);
    }

    const handleConfig = (field)=>{
        openSettings("School Fees Configuration", "ConfigSchoolFees", field, "Save Configuration");
    }

   
    const menu = ()=>{

        return(<>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-refresh"> </i><span>Refresh</span>
            </button>
           
        </>)
    }

    const extractValue = config=>{
        switch(config.config_code){
            case "payee_id":
                return config.config_value?.title || config.config_value;
            case "discount_cash_account":
                return functions.isObject(config.config_value) ? config.config_value.account_number + ' - ' + config.config_value.account_name  : config.config_value;
            case "discount_expense_account":
                return functions.isObject(config.config_value) ? config.config_value.account_number + ' - ' + config.config_value.account_name  : config.config_value;
            case "deferred_payment_account":
                return functions.isObject(config.config_value) ? config.config_value.account_number + ' - ' + config.config_value.account_name  : config.config_value;
            case "student_wallet_account":
                return functions.isObject(config.config_value) ? config.config_value.account_number + ' - ' + config.config_value.account_name : config.config_value;
            default:
                return config.config_value
        }
    }

    return (
        <SettingContainer
            title="School Fees"
            icon="fa fa-handshake"
            Menu={menu}
            >
      
            {functions.isObject(configListing) && <ul className="list-group">
                {Object.values(configListing).map((config) => (
                    
                    <SettingListItem
                        key={config.id} 
                        iconName={config.icon}
                        itemName={config.config_name}
                        itemDescription={extractValue(config)}
                        buttonTitle="Configure"
                        onSelect={()=>setActiveRecord(config)}
                        active={config.id === activeRecord?.id}
                        buttonAction={()=>handleConfig(config)}
                    />
                        
                ))}
            </ul>}
            {configListing === '404' && <Notification message="No school fees configuration found" />}
            {!configListing && <ActivityLoader />}
       </SettingContainer>

      
    );
};

export default SchoolFeesConfig;
